module.exports = __webpack_public_path__ + "images/category_lp/watch/case6_de6373cc76eff472947468e555dcafa3.jpg";